import axios from "axios";
const api = async (url) => {
  try {
    const response = await axios.get(url);
    console.log({ data: response.data.rows });
    return Promise.resolve(response.data);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export default { api };
